// "מה קורה בשוק היום" · the latest stored summary (sprint 18, stage 2).
//
// Written twice a trading day by netlify/functions/market-summary-scheduled.js
// into public.market_summaries (migrations/sprint18_market_summaries.sql).
// The app only reads the newest row. null = no summary at all, or the table
// is not there yet · the card then shows its empty state, never a stand-in.
import { supabase } from "../lib/supabase";

let memo = null;          // { at, row } · one read per 10 minutes
const TTL_MS = 10 * 60 * 1000;

export async function fetchLatestMarketSummary() {
  if (memo && Date.now() - memo.at < TTL_MS) return memo.row;
  if (!supabase) return null;
  const { data, error } = await supabase
    .from("market_summaries")
    .select("id, created_at, session_date, slot, lines, sources, indices")
    .order("created_at", { ascending: false })
    .limit(1);
  if (error) {
    // 42P01 / PGRST205: the table does not exist yet (the SQL has not run).
    if (!/42P01|PGRST205/.test(String(error.code))) console.warn("[marketSummary]", error.code, error.message);
    return null;
  }
  const row = data?.[0] || null;
  memo = { at: Date.now(), row };
  return row;
}

// Whether the summary was written today, by the Israel calendar day the
// reader is living in.
export function isFromToday(createdAt, now = new Date()) {
  const d = new Date(createdAt);
  if (!Number.isFinite(d.getTime())) return false;
  const day = x => x.toLocaleDateString("he-IL", { timeZone: "Asia/Jerusalem" });
  return day(d) === day(now);
}

// "16:02" today, "שישי 16.10.2026 · 23:31" otherwise · toLocaleDateString,
// never toISOString (which is UTC and can name the wrong day).
export function updatedLabel(createdAt, now = new Date()) {
  const d = new Date(createdAt);
  const time = d.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jerusalem" });
  if (isFromToday(d, now)) return time;
  const date = d.toLocaleDateString("he-IL", { weekday: "long", day: "numeric", month: "numeric", year: "numeric", timeZone: "Asia/Jerusalem" });
  return `${date} · ${time}`;
}
